export const CommonUsesData = [
  {
    title: "Immigration",
    detail:
      "Immigration documents almost always require certified translations, if your original documents are not in English. Ministry applications for visas, green cards and citizenship requirements can be made easier with certified translation services in Ottawa",
    link: "/uscis-translation-services",
  },
  {
    title: "University Applications",
    detail:
      "Are you going to study abroad or transfer to a university abroad? Our certified translation services help you gain acceptance in your dream university destination. Whether for high school, college or university, grad school, or postgraduate studies, Tomedes has solutions for you.",
    link: "/transcript-translation-services",
  },
  {
    title: "Job Applications",
    detail:
      "Are you looking for employment and need to pass in certified translations? At Tomedes, each certified translator knows the unique processes of the business sector you're applying for. You have the assurance of certification, translation, and dedicated translators.",
    // link: "/",
  },
  {
    title: "Other Government Entities",
    detail:
      "For your applications to the Global Affairs Ministry, Ministry of Transport, Ministry of Veterans Affairs, or abroad to USCIS or any other government entities, make sure to use translations that are certified. Many of these government agencies will require certified translations, and you've come to the right place.",
    // link: "/",
  },
];

export const CommonUsesDataSecond = [
  {
    title: "Legal Documents",
    detail:
      "For the legal profession, types of documents range from affidavits, agreements, contracts and much more. Our legal translators are well-versed in these types of documents, and in the legal sector in general. Meanwhile, they also have the knowledge of two or more languages. Get started today.",
    link: "/legal-translation.php",
  },
  {
    title: "Medical Documents",
    detail:
      "Documents for the medical field range from patient records, clinical history reports, lab results, and more. Being prepared to translate these medical documents are part and parcel of a medical translator's job. Their mastery of two or more languages plus their medical knowledge make them more than proficient.",
    link: "/medical-translation.php",
  },
  {
    title: "Technical Documents",
    detail:
      "Technical documents in fields such as data science and engineering may require translation. Technical documents such as user manuals, product manuals, and more can be transformed into translation. This includes glossaries of specific terminologies as well.",
    link: "/technical-translation.php",
  },
  {
    title: "Financial Documents",
    detail:
      "Financial documents are a necessary part of the everyday life of a business or an organization. These documents range from tax declarations, income statements, balance sheets, and much more. Tomedes translators have the know-how of the financial industry as well as of their specialized languages.",
    link: "/financial-translation.php",
  },
];
